import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVirustotalComponent } from './simple-icons-virustotal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVirustotalComponent ],
    exports:      [ SimpleIconsVirustotalComponent ],
    bootstrap:    []
})
export class SimpleIconsVirustotalModule {}
